import React, { useState, useEffect } from "react";
import { AuditCaseReportDownloadAction } from "../../Actions/cases";
import Modal from "react-bootstrap/Modal";
import { Icon } from "@iconify/react";
import "./FilePreviewModal.css";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

const FilePreviewModal = ({ show, onHide, fileUrl, caseNumber }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfError, setPdfError] = useState(null);
  const [scale, setScale] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (show && fileUrl) {
      setIsLoading(true);
      setPdfError(null);
      setPageNumber(1);
    }
  }, [show, fileUrl]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPdfError(null);
    setIsLoading(false);
  }

  function onDocumentLoadError(error) {
    console.error('PDF Load Error:', error);
    setPdfError(error);
    setIsLoading(false);
  }

  
  const zoomIn = () => {
    setScale(prevScale => Math.min(prevScale + 0.2, 3.0));
  };

  const zoomOut = () => {
    setScale(prevScale => Math.max(prevScale - 0.2, 0.2));
  };


  const handleDownload = async () => { 
    try {
      AuditCaseReportDownloadAction([
        { accessionNumber: caseNumber, fileUrl }
      ]);
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${caseNumber}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      contentClassName="border-[3px] border-[#605daf] rounded-lg">
      <div className="w-full bg-[#605daf] flex flex-row-reverse items-center justify-between px-4 py-2 rounded-t-lg">
        <div className="flex items-center gap-2">
          {fileUrl && (
            <button
              onClick={handleDownload}
              className="p-2 rounded hover:bg-[#7d6fd5] transition"
              title="Download PDF"
              style={{ color: "#fff" }}>
              <Icon icon="tabler:file-download" width="24" height="24" />
            </button>
          )}
          <button
            onClick={onHide}
            className="p-2 rounded hover:bg-[#7d6fd5] transition"
            style={{ color: "#fff" }}
            aria-label="Close">
            <Icon icon="tabler:x" width="24" height="24" />
          </button>
        </div>
        <span className="text-white text-lg font-semibold">
          PDF Preview
        </span>
      </div>
      <Modal.Body className="bg-white flex justify-center items-center overflow-auto rounded-b-lg p-4">
         <div className="absolute top-1 right-1 z-10 bg-white rounded-lg shadow-md p-2 flex items-center gap-2">
              <button
               className="w-7 border-solid border-2 border-primary1 text-primary1 rounded-md  hover:bg-primary1 hover:text-white"
                onClick={zoomOut}
              >-</button>
              <span className="text-gray-700">{Math.round(scale * 100)}%</span>
              <button
               className="w-7 border-solid border-2 border-primary1 text-primary1 rounded-md hover:bg-primary1 hover:text-white"
                onClick={zoomIn}
              >+</button>
            </div>
         <Document
                file={fileUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                loading={
                  <div className="flex justify-center items-center h-full">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary1"></div>
                  </div>
                }
                error={
                  <div className="text-red-500 text-center p-4">
                    Failed to load PDF. Please try again.
                  </div>
                }>
                <Page
                  pageNumber={pageNumber}
                  renderTextLayer={true}
                  renderAnnotationLayer={true}
                  scale={scale}
                  loading={
                    <div className="flex justify-center items-center h-full">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary1"></div>
                    </div>
                  }
                />
              </Document>
      </Modal.Body>
    </Modal>
  );
};

export default FilePreviewModal;
